
import DialogMixins from '@/mixins/DialogMixins';
import WidgetMixins from '@/mixins/WidgetMixins';
import { loadWidget } from '@/utils/helpers';
import Component, { mixins } from 'vue-class-component';
import { Getter, namespace } from 'vuex-class';
import moment from 'moment-timezone';
import { BroadcastRunStatus, IPaginate, ISmsBroadcast } from '@/types/types';
import { Watch } from 'vue-property-decorator';

const smsModule = namespace('sms');

@Component({
  name: 'Campaigns',
  components: {
    ToolBar: loadWidget('widgets/ToolBar'),
    SnackBar: loadWidget('widgets/SnackBar'),
  },
  filters: {
    timestamp(value: string, format?: string) {
      return value ? moment(value).format(format ?? 'Do MMMM, YYYY') : '-';
    },
  },
})
export default class Campaigns extends mixins(WidgetMixins, DialogMixins) {
  @Getter('getCreditBalance') creditBalance!: number;
  @smsModule.Getter('getBroadcasts') broadcasts!: Array<ISmsBroadcast>;
  @smsModule.Getter('getBroadcastsPagination') paginate!: {
    page: number;
    pages: number;
    total: number;
    limit: number;
  };
  @smsModule.Getter('getBroadcastDetails')
  broadcastDetails!: ISmsBroadcast | null;

  options: IPaginate = {
    itemsPerPage: 15,
    page: 1,
    total: 0,
  };
  expanded: Array<ISmsBroadcast> = [];

  headers = [
    { text: 'Campaign', value: 'name', sortable: false },
    { text: 'Status', value: 'broadcastStatus', sortable: false },
    { text: 'Delivery', value: 'progress', sortable: false },
    { text: 'Recipients', value: 'recipients', sortable: false },
    { text: 'Segments', value: 'totalSegments', sortable: false },
    { text: 'Launched / Scheduled', value: 'launchedAt', sortable: false },
    { text: '', value: 'data-table-expand' },
  ];

  campaignName(item: ISmsBroadcast): string {
    return item.name || 'Bulk send';
  }

  statusClass(status: BroadcastRunStatus): string {
    const classes: Record<BroadcastRunStatus, string> = {
      SCHEDULED: 'kx-status--info',
      RUNNING: 'kx-status--pending',
      FINISHED: 'kx-status--success',
      FAILED: 'kx-status--failed',
    };
    return classes[status] ?? 'kx-status--info';
  }

  detailsFor(item: ISmsBroadcast): ISmsBroadcast | null {
    return this.broadcastDetails?.transactionId === item.transactionId
      ? this.broadcastDetails
      : null;
  }

  onItemExpanded(payload: { item: ISmsBroadcast; value: boolean }): void {
    if (payload.value && payload.item.broadcastStatus !== 'SCHEDULED') {
      this.$store.dispatch('sms/broadcastDetails', payload.item.transactionId);
    }
  }

  refreshBroadcasts(): void {
    this.$store.dispatch('sms/listBroadcasts', {
      query: `?page=${this.options.page}&size=${this.options.itemsPerPage}`,
    });
  }

  @Watch('options')
  onOptionsChange(payload: IPaginate): void {
    this.$store.dispatch('sms/listBroadcasts', {
      query: `?page=${payload.page}&size=${payload.itemsPerPage}`,
    });
  }

  created(): void {
    this.$store.dispatch('checkCreditBalance');
  }
}
